export default "__VITE_ASSET__bLZdJrEx__"